// The site's address, read here and nowhere else: a page's own inputs, each declared with its type and read by it
// (?route a name, ?keys names, the Island's ?room a number...), and a setting's value for the visit (?old-style,
// ?sound=off), given to the provider (web/provider.js) for the settings store to check. No parameter is ever taken by
// its name alone, and nothing of @moonbase-machines reads an address. The types:
//   'boolean'      on or off: ?name and ?name=on are on, ?name=off is off
//   ['a', 'b']     one of fixed values (an enum), exactly one of them
//   'integer'      a whole number, 0 or more
//   'number'       a number, 0 or more (a pace, a part of the original's waits)
//   'name'         a word of letters, digits, underscores and dashes (a route's name, a key's)
//   'names'        a list of them, separated by commas
//
//   inputs(declared)      the page's inputs: { name: value } for each declared input ({ name: type }) that is in
//                         the address and is of its type; one that is not is left out and said
//   visit(def)            a setting's value for this visit, from its parameter by its declaration's type
//                         (@moonbase-machines/player/settings.js), or undefined: given to the provider as `visit`
const NAME = /^[\w-]+$/;
const WORDS = { boolean: 'on or off', integer: 'a whole number', number: 'a number', name: 'a name (letters, digits and dashes)', names: 'names separated by commas' };
const describe = type => Array.isArray(type) ? 'one of ' + type.map(v => v === '' ? 'nothing' : v).join(', ') : WORDS[type];

function parse(type, text) {
  if (Array.isArray(type)) return type.includes(text) ? text : undefined;
  switch (type) {
    case 'boolean': return text === '' || text === 'on' ? true : text === 'off' ? false : undefined;
    case 'integer': return /^\d+$/.test(text) ? Number(text) : undefined;
    case 'number': return /^\d+(\.\d+)?$/.test(text) ? Number(text) : undefined;
    case 'name': return NAME.test(text) ? text : undefined;
    case 'names': { const list = text.split(','); return list.every(n => NAME.test(n)) ? list : undefined; }
  }
  throw new Error('address: no such type: ' + JSON.stringify(type));
}
const read = (name, type) => {
  const q = new URLSearchParams(location.search);
  if (!q.has(name)) return undefined;
  const value = parse(type, q.get(name));
  if (value === undefined) console.warn(`?${name}=${q.get(name)} refused: not ${describe(type)}`);
  return value;
};

export function inputs(declared) {
  const out = {};
  for (const [name, type] of Object.entries(declared)) { const v = read(name, type); if (v !== undefined) out[name] = v; }
  return out;
}

export const visit = def => read(def.name, def.type);
